import {Component, OnInit} from '@angular/core';
import {ngxLoadingAnimationTypes} from 'ngx-loading';
import {Relay} from 'src/app/classes/Relay';
import {RelayBoardService} from '../../services/relay-board.service';

/**
 * @deprecated The component should not be used
 */
@Component({
  selector: 'app-relay',
  styleUrls: ['./relay.component.scss'],
  templateUrl: './relay.component.html',
})
export class RelayComponent implements OnInit {

  public state: Relay[];
  public backup: Relay[];
  public loading = false;
  public isError = false;
  public primaryColour = '#ffffff';
  public secondaryColour = '#ccc';
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  constructor(private relayService: RelayBoardService) {}

  ngOnInit(): void {
    this.updateState();
  }

  public updateState(): void {
    this.relayService.getCurrentState().subscribe({
      next: (response: Relay[]) => {
        this.state = response;
        this.backup = JSON.parse(JSON.stringify(response));
        this.isError = false;
      },
      error: (error) => this.isError = true,
    });
  }

  public toggleRelay(id: number): void {
    const relay = this.state[id];
    relay.enabled = !relay.enabled;
  }

  setState(): void {
    this.loading = true;
    this.relayService.setState(this.state)
      .subscribe({
        next: () => {
          this.relayService.getCurrentState().subscribe((response: Relay[]) => {
            this.state = response;
            this.backup = JSON.parse(JSON.stringify(response));
            this.loading = false;
            this.isError = false;
          });
        },
        error: (error) => this.isError = true,
      });
  }

  isNoChanges(): boolean {
    return JSON.stringify(this.backup) === JSON.stringify(this.state);
  }
}
